export default {"src":"/_next/static/media/rating-connector.527c7b2e.svg","height":8,"width":32,"blurWidth":0,"blurHeight":0};